// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";

let baseRoute = "/catalog";

let createRoute = baseRoute + "/create";

function productRoute(cku) {
  return baseRoute + "/product/" + cku;
}

let productCreateRoute = baseRoute + "/product/create";

function productEditRoute(cku) {
  return productRoute(cku) + "/edit";
}

function productRedirectRoute(cku) {
  return baseRoute + "/product/redirect/" + cku;
}

function productDuplicationRoute(cku) {
  return baseRoute + "/product/duplication/" + cku;
}

function variantRoute(cku) {
  return baseRoute + "/" + cku;
}

function variantEditRoute(cku) {
  return variantRoute(cku) + "/edit";
}

function variantCreateRoute(cku) {
  return variantRoute(cku) + "/create";
}

function createRedirectRoute(cku) {
  return createRoute + "/redirect/" + cku;
}

function variantDuplicationRoute(cku) {
  return baseRoute + "/duplication/" + cku;
}

function variantRedirectByIdRoute(id) {
  return baseRoute + "/redirect/" + id;
}

function variantStockActivitiesRoute(cku) {
  return variantRoute(cku) + "/stockactivities";
}

function variantOrderSuppliesRoute(cku) {
  return variantRoute(cku) + "/ordersupplies";
}

let labelsCreateRoute = baseRoute + "/labels/create";

let labelsCreateSettingsRoute = labelsCreateRoute + "/settings";

let inventoryImportRoute = baseRoute + "/inventory/import";

function encoder(param) {
  return [
    param.variantIdfromLabelEditSettings,
    param.fromPathname
  ];
}

function decoder(param) {
  return {
    TAG: "Ok",
    _0: {
      variantIdfromLabelEditSettings: param[0],
      fromPathname: param[1]
    }
  };
}

let value = JsonCodec.object2(encoder, decoder, JsonCodec.optional(JsonCodec.field("variantIdfromLabelEditSettings", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("fromPathname", JsonCodec.string)));

let Codecs = {
  encoder: encoder,
  decoder: decoder,
  value: value
};

function encode(state) {
  return QueryString.stringify(JsonCodec.encodeWith(state, value));
}

function decode(query) {
  let state = JsonCodec.decodeWith(QueryString.parse(query), value);
  if (state.TAG === "Ok") {
    return state._0;
  } else {
    return {
      variantIdfromLabelEditSettings: undefined,
      fromPathname: undefined
    };
  }
}

let CatalogLabelQueryString = {
  Codecs: Codecs,
  encode: encode,
  decode: decode
};

export {
  baseRoute,
  createRoute,
  productRoute,
  productCreateRoute,
  productEditRoute,
  productRedirectRoute,
  productDuplicationRoute,
  variantRoute,
  variantEditRoute,
  variantCreateRoute,
  createRedirectRoute,
  variantDuplicationRoute,
  variantRedirectByIdRoute,
  variantStockActivitiesRoute,
  variantOrderSuppliesRoute,
  labelsCreateRoute,
  labelsCreateSettingsRoute,
  inventoryImportRoute,
  CatalogLabelQueryString,
}
/* value Not a pure module */
